import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../apps/consumer/graphql/fragments/global';
import {
  PhotoForegroundDetails,
  PhotoWallpaperWatermarkDetails,
} from '../../../../graphql/fragments/photo';

const getAccountCardMembershipGroupIdentityConfigurationPhotosQuery = gql`
  query getAccountCardMembershipGroupIdentityConfigurationPhotos(
    $limit: Int = 40
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $allPhotosOffset: Int = 0
    $album_membership_group_id: RecordID!
    $identity_id: RecordID
  ) {
    albumMembershipGroup(
      id: $album_membership_group_id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      identities(identity_ids: [$identity_id]) {
        matched_photos_extended(
          slice: { limit: $limit, offset: $matchesOffset }
        ) {
          total
          count
          records {
            id
            photo {
              id
              thumbnail_urls(ignore_watermark: true) {
                ...PhotoUrlTypeFields
              }
              faceblocked_thumbnail_urls {
                url
                size_code
                width
                height
                blur_type
                regions
              }
              ...PhotoWallpaperWatermarkDetails
              is_entitled_matched_photo
              is_owner
              faces {
                total
              }
              ...PhotoForegroundDetails
            }
            album {
              id
            }
            faceblocked_thumbnail_urls {
              url
              size_code
              width
              height
              blur_type
              regions
            }
          }
        }
      }
      favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
      all_photos(
        slice: { limit: $limit, offset: $allPhotosOffset }
        use_all_photos_mode: true
      ) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          albums(slice: { limit: 1 }) {
            records {
              id
              name
              album_type
              album_subtype
            }
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${PhotoForegroundDetails}
  ${PhotoWallpaperWatermarkDetails}
`;

export default getAccountCardMembershipGroupIdentityConfigurationPhotosQuery;
